import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import type { Activite } from "../../types/entities";

export const useGetActivites = () =>
  useQuery({
    queryKey: ["activites"],
    queryFn: async (): Promise<Activite[]> => {
      const resp = await fetchClient<Activite[]>("/iam/activite/");
      if (resp.error || !resp.data) throw resp.error || new Error("Failed to fetch Activites");
      return resp.data;
    },
    staleTime: 5 * 60 * 1000,
  });

export default useGetActivites;
